export const GAME_FAV_STATS = "GAME_FAV_STATS";